<template>
  <div>
    

  <div class="row pad">
    
      <div class="col s12 m8m">


<div class="row">
          <div class="col s4 m12"><img src="../assets/logo.png" style="height:80px;"/></div>
          <div class="col s8 m12"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
        </div>


        <div class="row pad-in" v-for="(itm, index)  in $socio._si"  :key="index" :class="'item_'+itm.id" v-if="(itm.dimesso!=1 && itm.societa!=169)" style ="margin-top:20px;">
          <div class="col s1m yo-align-left yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'sigla')}}</div>
          <div class="col s4 yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'nome')}}</div>
          <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.dimesso==0">in regola al {{itm.ultimoanno}}</div>
          <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.societa==169 && itm.dimesso==0">anno {{itm.ultimoanno}}</div>
         <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.dimesso==1">dimesso</div>
        </div> 

        <div class="row pad-in" v-for="(itm, index)  in $socio._si"  :key="index" :class="'item_'+itm.id" v-if="(itm.ultimoanno>$moment().format('YYYY')-1 && itm.societa==169)" style ="margin-top:20px;">
          <div class="col s1m yo-align-left yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'sigla')}}</div>
          <div class="col s4 yo-valign-text-center" style="height:50px;">{{itm.societa | items($teras._societa,'nome')}}</div>
          <div class="col s2m yo-valign-text-center yo-align-right" style="height:50px;" v-if="itm.dimesso==0">in regola al {{itm.ultimoanno}}</div>
        </div>




      


    <el-collapse v-if="false">
  


  <el-collapse-item  v-for="(itm, index) in $socio._si" :item="itm" v-bind:key="index" :name="itm.societa">
    <template slot="title">
      <div class="row">
        <div class="col s8">{{itm.societa | items($teras._societa,'sigla')}} - {{itm.societa | items($teras._societa,'nome')}}</div>
        <div class="col s3m yo-align-right">in regola al {{itm.ultimoanno}}</div>
      </div>
    </template>
      <siHome :item="itm" ></siHome>
  </el-collapse-item>
  






  <el-collapse-item name="versamenti" v-if="false">
    <template slot="title">
      <div class="row">
        <div class="col s8"><h2>Versamenti</h2></div>
        <div class="col s3m yo-align-right" v-if="this.$socio._versamento.length>0">ultimo effetuato il {{$socio._versamento[0].inseritoil | data()}} di {{$socio._versamento[0].importo | money('€ ')}}</div>
      </div>
    </template>

    <versamento></versamento>

  </el-collapse-item>



</el-collapse>



        <div class="row pad" style="margin-top:30px;" v-if="$teras.app.device!='mobile'">
          <!--
            <div class="col s12 m4 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-edit" class="white">PROFILO</router-link></div>
          <div class="col s12 m4 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-password" class="white">CREDENZIALI</router-link></div>
          -->
          <div class="col s12 m6 offset-m6 yo-bg-color-secondary yo-align-center" style="padding-top:10px;padding-bottom:10px;"><router-link to="/contatto-rinnovo" class="white">RINNOVO</router-link></div> 
        </div>
<br />
<hr />
<br />


    <div class="row">
      <div class="col s12"><h2>Versamenti</h2>
      <div style="padding-bottom:16px;" v-if="this.$socio._versamento.length>0">ultimo effetuato il {{$socio._versamento[0].eseguitoil | data()}} di {{$socio._versamento[0].importo | money('€ ')}}</div>
      
      </div>
    </div>


    <versamento></versamento>



      </div>

      <div class="col s12 m3m">
        <contattoSide></contattoSide>
      </div>

    </div>



</div>
</template>

<script>
import siHome from './Si-home.vue'
import contattoSide from './Contatto-side.vue'
import versamento from './Versamento.vue'

export default {
   name: 'home'
   ,components: {
    contattoSide
    ,siHome
    ,versamento
  }
  ,data () {
    return {
    }
     



  }
  ,created () {

    if(this.$moment(this.$socio.si.row.authbasic).format('YYYY')<this.$moment().format('YYYY'))
      this.$router.push('/contatto-edit')
  }
  ,mounted () {
    if(this.$socio.contatto.row.codicefiscale=='')
      this.$router.push('/contatto-edit')
    
  }
   
}
</script>
